import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { InternalAccount, InternalNpsPeriod } from 'types/GlobalInternalAccount'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

export const selectAccounts = createSelector(
  [(state: ApplicationState) => state.InternalAccountStore.data],
  (data): InternalAccount[] =>
    Object.values(data).sort((a, b) =>
      sortAlphabeticalAsc(a.full_name, b.full_name)
    )
)

export const selectAccountsFetchStatus = (state: ApplicationState) =>
  state.InternalAccountStore.fetchStatus

export const selectAccount = (
  state: ApplicationState,
  id: string
): InternalAccount | null => state.InternalAccountStore.data[id] ?? null

export const selectAccountNps = (
  state: ApplicationState,
  id: string
): InternalNpsPeriod[] | null => state.InternalAccountStore.nps[id] ?? null
